document.querySelector('#mobile-menu-button').addEventListener('click', function(){
    document.querySelector('#mobile-menu').classList.toggle('hidden');
    document.querySelectorAll('.mobile-menu-icon').forEach(function(icon){icon.classList.toggle('hidden')});
});

document.querySelector('#mobile-menu').addEventListener('click', function(e) {
    if (!e.target.matches('span.mobile-menu-item')) return;
    e.target.nextElementSibling.classList.toggle('hidden');
    e.target.childNodes[0].classList.toggle('fa-arrow-down');
    e.target.childNodes[0].classList.toggle('fa-arrow-right');
});


if (document.querySelector('#photo-gallery') !== null) {
    let activeGalleryImage = null;

    document.querySelector('#photo-gallery').addEventListener('click', function(e){
        if (!e.target.matches('.gallery-image')) return;
        activeGalleryImage = e.target;

        document.querySelector('#full-image-container').classList.remove('hidden');
        document.querySelector('#full-image').src = '';
        document.querySelector('#full-image').src = activeGalleryImage.dataset.image;

        checkPrevNextImage();
    });
    
    document.querySelector('#full-image').addEventListener('click', function(){
        document.querySelector('#full-image-container').classList.add('hidden');
        activeGalleryImage = null;
    });
    
    document.querySelector('#full-image-backwards').addEventListener('click', prevImage);
    document.querySelector('#full-image-forward').addEventListener('click', nextImage);
    document.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowLeft' && activeGalleryImage !== null) prevImage();
        if (e.key === 'ArrowRight' && activeGalleryImage !== null) nextImage();
        if (e.key === 'Escape' && activeGalleryImage !== null) {
            document.querySelector('#full-image-container').classList.add('hidden');
            activeGalleryImage = null;
        }
    })

    function prevImage() {
        if (activeGalleryImage.previousElementSibling !== null) {
            activeGalleryImage = activeGalleryImage.previousElementSibling;
            document.querySelector('#full-image').src = '';
            document.querySelector('#full-image').src = activeGalleryImage.dataset.image;

            checkPrevNextImage();
        }
    }

    function nextImage() {
        if (activeGalleryImage.nextElementSibling !== null) {
            activeGalleryImage = activeGalleryImage.nextElementSibling;
            document.querySelector('#full-image').src = '';
            document.querySelector('#full-image').src = activeGalleryImage.dataset.image;

            checkPrevNextImage();
        }
    }

    function checkPrevNextImage() {
        if (activeGalleryImage.previousElementSibling === null) {
            document.querySelector('#full-image-backwards').classList.add('hidden');
        } else {
            document.querySelector('#full-image-backwards').classList.remove('hidden');
        }

        if (activeGalleryImage.nextElementSibling === null) {
            document.querySelector('#full-image-forward').classList.add('hidden');
        } else {
            document.querySelector('#full-image-forward').classList.remove('hidden');
        }
    }
}